import { logger } from '@/lib/logger'

import type {
  AnalyticsProvider,
  EventProperties,
  UserProperties,
} from './types'

class Analytics {
  private providers: Array<AnalyticsProvider> = []
  registerProvider(provider: AnalyticsProvider): void {
    this.providers.push(provider)
  }

  track(eventName: string, properties?: EventProperties): void {
    const enriched = properties ?? {}
    for (const provider of this.providers) {
      try {
        provider.track(eventName, enriched)
      } catch (error) {
        logger.error('Analytics track failed', {
          provider: provider.name,
          eventName,
          error,
        })
      }
    }
  }

  identify(userId: string): void {
    for (const provider of this.providers) {
      try {
        provider.identify(userId)
      } catch (error) {
        logger.error('Analytics identify failed', {
          provider: provider.name,
          userId,
          error,
        })
      }
    }
  }

  alias(newId: string, previousId?: string): void {
    for (const provider of this.providers) {
      try {
        provider.alias(newId, previousId)
      } catch (error) {
        logger.error('Analytics alias failed', {
          provider: provider.name,
          newId,
          previousId,
          error,
        })
      }
    }
  }

  setUserProperties(properties: UserProperties): void {
    for (const provider of this.providers) {
      try {
        provider.setUserProperties(properties)
      } catch (error) {
        logger.error('Analytics setUserProperties failed', {
          provider: provider.name,
          error,
        })
      }
    }
  }

  reset(): void {
    for (const provider of this.providers) {
      try {
        provider.reset()
      } catch (error) {
        logger.error('Analytics reset failed', {
          provider: provider.name,
          error,
        })
      }
    }
  }
}

export const analytics = new Analytics()
